import React, { useEffect } from "react";
import { GridContainer } from "./QuestionIdentifier.styles";
import { Button, Grid, TextField } from "@mui/material";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { requiredFieldRule } from "../../../../../validation/question/rules";
import { requiredFieldErrorMessage } from "../../../../../validation/question/errors";
import { QuestionsApi } from "../../../../../api/questions/QuestionsApi";
import { useLocation } from "react-router-dom";

interface QuestionIdentifierProps {
	prefix: string;
	isSubquestion: boolean;
}

export default function QuestionIdentifier({ prefix, isSubquestion }: QuestionIdentifierProps) {
	const { control, setValue, getValues } = useFormContext();
	const { pathname } = useLocation();

	const onGetIdentifier = async () => {
		const response = (await QuestionsApi.getQuestions({
			sort: "-number",
			"page[size]": "1",
			"page[number]": "1",
		})) as unknown as { data: [{ attributes: { number: number } }] };
		setValue(`${prefix}number`, response.data[0].attributes.number + 10);
		setValue(`${prefix}title`, `Задача ${response.data[0].attributes.number + 10}`);
	};
	const number = useWatch({
		name: "number",
	});
	const order = useWatch({
		name: `${prefix}order`,
	});

	useEffect(() => {
		if (isSubquestion) {
			setValue(`${prefix}number`, number + order);
		}
	}, [number, order]);

	return (
		<GridContainer container item>
			<Grid container item xs={12} columnGap={1} justifyContent={"flex-start"}>
				<Controller
					render={({ field, fieldState: { error } }) => (
						<TextField
							sx={(theme) => ({ margin: theme.spacing(1, 0) })}
							size={"small"}
							variant={"outlined"}
							label={"Номер"}
							{...field}
							error={!!error}
							disabled={isSubquestion}
							helperText={requiredFieldErrorMessage(error)}
						/>
					)}
					control={control}
					name={`${prefix}number`}
					defaultValue={isSubquestion ? getValues("number") : ""}
					{...requiredFieldRule()}
				/>
				<Controller
					render={({ field, fieldState: { error } }) => (
						<TextField
							sx={(theme) => ({ margin: theme.spacing(1, 0) })}
							size={"small"}
							variant={"outlined"}
							label={"Заголовок"}
							{...field}
							error={!!error}
							helperText={requiredFieldErrorMessage(error)}
						/>
					)}
					control={control}
					name={`${prefix}title`}
					defaultValue={isSubquestion ? `Задача ${getValues("number")}, вопрос ${getValues(`${prefix}order`)}` : ""}
					{...requiredFieldRule()}
				/>
			</Grid>
			{!isSubquestion && !pathname.includes("edit") ? (
				<Button onClick={onGetIdentifier} variant={"text"} size={"small"}>
					Получить номер задачи
				</Button>
			) : null}
		</GridContainer>
	);
}
